module.exports = __webpack_public_path__ + "8326e2696efddf90e79a884f02d5eaa2.glb";